import { defineMessages } from '@atlassian/jira-intl'; /* Disabling the i18n-named-by-file because these strings are already translated
   and renaming would kill all the translations.
 */

export default defineMessages({
	modalHeader: {
		id: 'project-details.modal.header',
		defaultMessage: 'Delete “{projectName}”',
		description: '',
	},
	explainWhatDeleteDoes: {
		id: 'project-details.modal.description.former',
		defaultMessage:
			'Deleting a project removes every last trace of information, data, and work history.',
		description: '',
	},
	explainWhatDeleteServiceProjectDoes: {
		id: 'project-details.modal.description.former.serviceproject',
		defaultMessage:
			'Deleting a service project removes every last trace of information, data, and work history.',
		description: 'This is an explanation in a modal confirmation dialog for deleting a project',
	},
	backupCallToActionPart1: {
		id: 'project-details.delete-modal.description.action.part1',
		defaultMessage: 'You might want to make a',
		description: '',
	},
	backupCallToActionPart2: {
		id: 'project-details.delete-modal.description.action.part2',
		defaultMessage: 'backup',
		description: '',
	},
	backupCallToActionPart3: {
		id: 'project-details.delete-modal.description.action.part3',
		defaultMessage: 'before you continue.',
		description: '',
	},
	cannotBeUndone: {
		id: 'project-details.delete-modal.description.action.undone',
		defaultMessage: "This can't be undone.",
		description: 'Lets the user know deleting a project cannot be undone',
	},
	confirmDeleteButton: {
		id: 'project-details.modal.action-delete',
		defaultMessage: 'Delete',
		description: '',
	},
	cancelDeleteButton: {
		id: 'project-details.modal.action-cancel',
		defaultMessage: 'Cancel',
		description: '',
	},
});
